import React, { Component } from 'react'

class SimpleLeyenda extends Component {
  render () {
    const { items } = this.props
    if (!items || items.length === 0)
      return null

    return (
      <div className="leyenda">
        <ul>
          {items.map((item, idx) => {
            return (
              <li key={idx}>
                {item.type === 'pool_parcial' ? (
                  <div style={{
                    background: "linear-gradient(to bottom, rgb(37, 56, 170) 60%, white 50%)",
                    border: item.border ? "1px solid " + item.border : ""
                  }}></div>
                ) : (
                  <div style={{
                    backgroundColor: item.color,
                    border: item.border ? "1px solid " + item.border : ""
                  }}></div>
                )}

                {item.name === "&nbsp;" ? <>&nbsp;</> : item.name}
              </li>
            )
          })}
        </ul>
      </div>
    )
  }
}

export default SimpleLeyenda